export default "__VITE_ASSET__B4TsTSI4__"